import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'

const Page403 = () => {
  return (
    <LayoutMain>
		{/* <MyBlock>
			<h2>Партії товарів (QR-коди) з замовлення KeyCRM</h2>
		</MyBlock> */}
		<MyBlockHeader
            header={'Доступ до сторінки заборонений'}
            // options={
            //     <PackOptions />
            // }
        />
		{/* <MyBlock>
            <h2>Досутп </h2>
		</MyBlock> */}
    </LayoutMain>
  )
}

export default Page403